import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "19",
  fill: "none",
  viewBox: "0 0 23 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.6 13.96 1.227 6.174q-.484-2.66 2.223-3.126L14.643 1.07c1.793-.311 2.846.409 3.158 2.181l.419 2.363h1.88c1.826 0 2.739.892 2.739 2.697v7.906c0 1.794-.913 2.696-2.74 2.696H8.714c-1.826 0-2.74-.892-2.74-2.696v-.118l-.214.032c-1.805.311-2.847-.398-3.158-2.17m1.504-.354c.15.806.656 1.128 1.408 1l.462-.076V8.31c0-1.804.913-2.696 2.739-2.696h7.938l-.354-2.009c-.14-.805-.655-1.138-1.407-.999L3.74 4.562c-.763.128-1.118.623-.978 1.428zm3.427-5.21v6.811l1.762-1.525c.333-.269.645-.409.967-.409.344 0 .698.13 1.02.42l1.365 1.224 3.383-3.019c.333-.3.71-.43 1.117-.43.387 0 .795.14 1.107.441l3.04 2.89V8.396c0-.816-.44-1.235-1.214-1.235H8.734c-.773 0-1.203.42-1.203 1.235M12 12.113a1.795 1.795 0 0 1-1.783-1.794A1.79 1.79 0 0 1 12 8.547c.977 0 1.773.806 1.773 1.772 0 .989-.796 1.794-1.773 1.794"
    }, null, -1)
  ])))
}
export default { render: render }